module.exports = __webpack_public_path__ + "img/logo-20180504.0f937001.png";